import {SceneInjectionChain} from "../gameobjects/SceneInjectionChain";
import {SceneInjectionCharacterReaction} from "../gameobjects/SceneInjectionCharacterReaction";
import {SceneInjectionOptionFilter} from "../gameobjects/SceneInjectionOptionFilter";
import {SceneInjectionPlayVO} from "../gameobjects/SceneInjectionPlayVO";
import {SceneInjectionSfxVolume, SceneInjectionStopSfx} from "../gameobjects/SceneSfxInjections";
import {MayaAngelouCutouts} from "../layout/MayaAngelouCutouts";
import {
    MayaAngelouStoryLayout_scene1Start,
    MayaAngelouStoryLayout_scene2Likes,
    MayaAngelouStoryLayout_scene3Brave,
    MayaAngelouStoryLayout_scene4Dance,
    MayaAngelouStoryLayout_scene5Power,
    MayaAngelouStoryLayout_scene6Bed,
    MayaAngelouStoryLayout_scene7End,
} from "../layout/MayaAngelouStoryLayout";
import {BookId} from "./BookId";
import {CharacterType} from "./CharacterType";
import {CutoutData} from "./CutoutData";
import {SFX, SFXMap} from "./SFX";
import {StoryModel} from "./StoryModel";

export const StoryMayaAngelou: StoryModel<MayaAngelouSceneId, MayaAngelouSlotId> = {
    storyId: BookId.Angelou,
    storyIndex: 5,
    promptVO: "{index}_XRSC_MA_YADINA",
    optionVO: "{index}_XRSC_MA_YADINA",
    optionIcon: "ang-{option}-buttonimg",
    introVO: ["002_XRSC_MA_YADINA", "003_XRSC_MA_XAVIER", "004_XRSC_MA_BRAD", "005_XRSC_MA_YADINA"],
    bookIdleVO: ["002_XRSC_MA_YADINA", "003_XRSC_MA_XAVIER", "004_XRSC_MA_BRAD", "005_XRSC_MA_YADINA"],
    outroVO: ["048_XRSC_MA_BRAD", "049_XRSC_MA_YADINA", "050_XRSC_MA_XAVIER"],
    outroImage: undefined,
    cutouts: new CutoutData(MayaAngelouCutouts),
    scenes: [
        {
            sceneId: "start",
            cc: "A rhyming poem about Dr. Zoom? How should we start? Dr. Zoom {option-start!}",
            sfx: SFX("002"),
            vo: "007_ALT_XRSC_MA_YADINA",
            sfxLoop: [SFXMap["101"]],
            options: [
                {optionId: "smart", cc: "is SUPER smart", iconPosition: "center", sfx: SFX({"002": 0, "091": 1.6}), voIndex: 8},
                {optionId: "art", cc: "is ah-mazing at art", iconPosition: "center", sfx: SFX({"002": 0, "101": 1.6}), voIndex: 9},
                {optionId: "heart", cc: "has the BIGGEST heart", iconPosition: "center", sfx: SFX({"002": 0, "097": 1.6}), voIndex: 10},
                {optionId: "counterpart", cc: "is my counterpart", iconPosition: {x: 20, y: -6}, sfx: SFX("026"), voIndex: 11},
            ],
            layout: MayaAngelouStoryLayout_scene1Start,
            injections: {
                afterFullVO: new SceneInjectionCharacterReaction(CharacterType.Yadina, "012_XRSC_MA_YADINA"),
            },
        },
        {
            sceneId: "likes",
            cc: "Also, Dr. Zoom <em>LOVES</em> tea <em>ALMOST</em> as much as {option-likes!}",
            voIndex: 13,
            sfxLoop: [SFXMap["099"], SFXMap["061"]],
            sfxVolume: {[SFXMap["061"]]: 0.5, [SFXMap["099"]]: 0.6},
            options: [
                {optionId: "jelly", cc: "sandwiches with grape jelly", iconPosition: "center", sfx: SFX({"007": 0, "062": 1.6}), voIndex: 14},
                {optionId: "party", cc: "having a turtle party", iconPosition: "center", sfx: SFX({"061": 0}), voIndex: 17},
                {optionId: "marshmallow", cc: "a pie that's MARSH-MALLOWY", iconPosition: "center", sfx: SFX({"073": 0, "019": 0, "049": 0.4, "062": 1.6}), voIndex: 16},
                {optionId: "sea", cc: "swimming under the sea", iconPosition: "center", sfx: SFX({"074": 0, "099": 1.6}), voIndex: 15},
            ],
            layout: MayaAngelouStoryLayout_scene2Likes,
            injections: {
                afterFullVO: new SceneInjectionCharacterReaction(CharacterType.Brad, "re_brad_006_alt"),
            },
        },
        {
            sceneId: "brave",
            cc: "Dr. Zoom's brave and tries new things, like {option-brave!}",
            voIndex: 18,
            sfxLoop: [SFXMap["093"]],
            options: [
                {optionId: "wings", cc: "flying with wings", iconPosition: "center", sfx: SFX("044", "073"), voIndex: 19},
                {optionId: "springs", cc: "bouncing on springs", iconPosition: "center", sfx: SFX("094"), voIndex: 20},
                {optionId: "rings", cc: "eating onion rings", iconPosition: "center", sfx: SFX({"036b": 0, "062": 2.4}), voIndex: 21},
                {optionId: "swings", cc: "riding the swings", iconPosition: "center", sfx: SFX("093", "100"), voIndex: 22},
            ],
            layout: MayaAngelouStoryLayout_scene3Brave,
            injections: {
                afterFullVO: new SceneInjectionOptionFilter(
                    ["brave", "swings", new SceneInjectionChain(
                        new SceneInjectionPlayVO("vo-6-2-2B-1-yadina"),
                        new SceneInjectionCharacterReaction(CharacterType.Yadina, "023_XRSC_MA_YADINA"),
                    )],
                    new SceneInjectionCharacterReaction(CharacterType.Yadina, "023_XRSC_MA_YADINA"),
                ),
            },
        },
        {
            sceneId: "dance",
            cc: "Dr. Zoom can spend all afternoon, dancing {option-dance!}",
            sfx: SFX({"001": 0.75, "073": 0}),
            sfxLoop: [SFXMap["001"]],
            sfxVolume: {[SFXMap["001"]]: 0.5},
            voIndex: 24,
            options: [
                {optionId: "balloon", cc: "on a balloon", iconPosition: "center", voIndex: 25},
                {optionId: "moon", cc: "on the moon", iconPosition: "center", voIndex: 26},
                {optionId: "spoon", cc: "on a spoon", voIndex: 27},
                {optionId: "raccoon", cc: "with a raccoon", voIndex: 28},
            ],
            layout: MayaAngelouStoryLayout_scene4Dance,
            injections: {
                afterFullVO: new SceneInjectionChain(
                    new SceneInjectionCharacterReaction(CharacterType.Yadina, "028b_XRSC_MA_YADINA"),
                    new SceneInjectionSfxVolume(1, SFXMap["001"]),
                ),
            },
        },
        {
            sceneId: "power",
            cc: "Did you know Dr. Zoom's favorite power, is {option-power!}",
            voIndex: 29,
            sfxVolume: {[SFXMap["088"]]: 0.5},
            options: [
                {optionId: "shower", cc: "singing in the shower", iconPosition: "center", sfx: SFX("012", "088"), voIndex: 30, labelSize: 18},
                {optionId: "flower", cc: "smelling a pretty flower", iconPosition: "center", sfx: SFX({"012": 0, "090": 1.6}), voIndex: 31, labelSize: 18},
                {optionId: "tower", cc: "climbing up a PIZZA tower", iconPosition: "center", sfx: SFX("011"), voIndex: 32, labelSize: 18},
                {optionId: "hour", cc: "sitting still for an entire hour", iconPosition: "center", sfx: SFX("012", "089a"), voIndex: 33, labelSize: 18},
            ],
            layout: MayaAngelouStoryLayout_scene5Power,
            injections: {
                afterFullVO: new SceneInjectionCharacterReaction(CharacterType.Yadina, "034_XRSC_MA_YADINA"),
                afterAnimation: new SceneInjectionStopSfx(SFXMap["089a"]),
            },
        },
        {
            sceneId: "bed",
            cc: "And, when it's time for bed, Dr. Zoom likes to cuddle on {option-bed!}",
            sfx: SFX("075"),
            voIndex: 35,
            options: [
                {optionId: "sled", cc: "a GIANT sled", iconPosition: "center", voIndex: 36},
                {optionId: "bread", cc: "a slice of bread", iconPosition: "center", sfx: SFX({"075": 0, "023": 0.5}), voIndex: 37},
                {optionId: "head", cc: "my sleepy head", iconPosition: {x: 5, y: -7}, voIndex: 38},
                {optionId: "fred", cc: "a pillow named Fred", iconPosition: "center", sfx: SFX({"075": 0, "023": 0.5}), voIndex: 39},
            ],
            layout: MayaAngelouStoryLayout_scene6Bed,
            injections: {
                afterFullVO: new SceneInjectionCharacterReaction(CharacterType.Yadina, "040_XRSC_MA_YADINA"),
            },
        },
        {
            sceneId: "end",
            cc: "And even though our poem is just about done, Dr. Zoom, you're {option-end!}",
            voIndex: 41,
            options: [
                {optionId: "one", cc: "number one", iconPosition: "center", sfx: SFX("025"), voIndex: 42},
                {optionId: "fun", cc: "turtletastic fun", iconPosition: {x: 0, y: -6}, sfx: SFX("084"), voIndex: 43},
                {optionId: "ton", cc: "loved a ton", iconPosition: {x: 0, y: -6}, sfx: SFX("042", "078"), voIndex: 45},
                {optionId: "anyone", cc: "a friend to anyone", iconPosition: "center", sfx: SFX("015"), voIndex: 44},
            ],
            layout: MayaAngelouStoryLayout_scene7End,
            injections: {
                afterFullVO: new SceneInjectionChain(
                    new SceneInjectionCharacterReaction(CharacterType.Xavier, "046_XRSC_MA_XAVIER", true),
                    new SceneInjectionCharacterReaction(CharacterType.Yadina, "047_XRSC_MA_YADINA")),
            },
        },
    ],
};

export type MayaAngelouSceneId =
    "start"
    | "likes"
    | "brave"
    | "dance"
    | "power"
    | "bed"
    | "end";
export type MayaAngelouSlotId = MayaAngelouSceneId;
